var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 1